import { render, staticRenderFns } from "./OchartCharacter.vue?vue&type=template&id=172f2fb8&scoped=true"
import script from "./OchartCharacter.vue?vue&type=script&lang=js"
export * from "./OchartCharacter.vue?vue&type=script&lang=js"
import style0 from "./OchartCharacter.vue?vue&type=style&index=0&id=172f2fb8&prod&lang=css"
import style1 from "./OchartCharacter.vue?vue&type=style&index=1&id=172f2fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172f2fb8",
  null
  
)

export default component.exports